<template>
  <sInputNumber
    v-bind="numberOptions"
    clearable
    :data-qa="dataQa"
    :minus="true"
    output-type="String"
    :precision="criteria.props.allowDecimals ? 5 : 0"
    :use-thousand-separator="true"
    :value.sync="valueMutable"/>
</template>
<script>
export default {
  name: 'numericInput',
  data() {
    return {}
  },
  methods: {},
  computed: {
    valueMutable: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    },
    numberOptions() {
      const result = {}

      // Проверяем minValue и maxValue, включая 0 как валидное значение
      if (this.criteria.props.minValue !== null && this.criteria.props.minValue !== undefined) {
        result.min = this.criteria.props.minValue
      }

      if (this.criteria.props.maxValue !== null && this.criteria.props.maxValue !== undefined) {
        result.max = this.criteria.props.maxValue
      }

      // Устанавливаем placeholder в зависимости от allowDecimals
      if (this.criteria.props.allowDecimals) {
        result.placeholder = '0.' + '0'.repeat(this.criteria.props.allowDecimals)
      } else {
        result.placeholder = '0'
      }

      return result
    }
  },
  props: {
    dataQa: {
      type: String,
      default: 'numeric_input-value'
    },
    value: {
      type: String
    },
    criteria: {
      type: Object,
    },
  }
}
</script>
